module.exports = __webpack_public_path__ + "media/images/lamp/remark_arrow-2b183e360b14d069153f5cef59638d8b.png";